




























































import { Component, Vue } from 'vue-property-decorator';

import api from '@/util/api';

@Component ({})
export default class Register extends Vue
{
	// Properties

	geoLocation: any = null;
	user = {
		name: '',
		email: '',
		phone: ''
	};



	// Computed

	get isPet ()
	{
		return this.tag.type == 'pet';
	}

	get isPerson ()
	{
		return this.tag.type == 'person';
	}

	get isSuitcase ()
	{
		return this.tag.type == 'suitcase';
	}

	get okMessage ()
	{
		if (this.isPerson)
			return `Muchas gracias. Estamos enviando tus datos a la familia de ${this.name} para que se contacte contigo.`;
		if (this.isPet || this.isSuitcase)
			return `Muchas gracias, estamos enviando tus datos al dueño de ${this.name} para que se contacte contigo.`;
		return 'indefinido';
	}

	get name ()
	{
		if (this.isPet)
			return this.tag.pet.nationalid ?
				`${this.tag.pet.name} (${this.tag.pet.nationalid})` :
				this.tag.pet.name;
		if (this.isSuitcase)
			return this.tag.suitcase.name;
		if (this.isPerson)
			return this.tag.person.name;
		return 'indefinido';
	}
	get tag ()
	{
		return this.$store.state.tag;
	}



	// Events

	created ()
	{
		if (!this.tag)
			return this.$router.replace ('/');
		if (!this.tag.registered)
			return this.$router.replace ('/');
		// @ts-ignore
		this.$getLocation ().then (coordinates =>
		{
			this.geoLocation = coordinates;
			this.notifyScan ();
		});
	}



	// Methods

	async notifyScan ()
	{
		try
		{
			await api.notifyScan ({
				id: this.tag.id,
				geoLocation: this.geoLocation
			});
		}
		catch (e)
		{
			// Ignoring error
		}
	}

	async notifyFound ()
	{
		if (!await this.$validator.validateAll ())
			return await this.setMessage (
				'Formulario incompleto',
				'Por favor, llene todos los campos del formulario',
				true
			);

		try
		{
			await api.notifyFound ({
				id: this.tag.id,
				geoLocation: this.geoLocation,
				user: this.user
			});
			await this.setMessage (
				'Gracias',
				this.okMessage,
				false,
				'http://nomepierdo.cl/gracias-por-tu-ayuda/');
		}
		catch (e)
		{
			await this.setMessage (
				'Error',
				e.message,
				true);
		}
	}

	setMessage (message: string, details: string, error = false, nextUrl: string | null = null)
	{
		return this.$store.dispatch ('setMessage', { message, details, error, nextUrl });
	}
}

